import { NgClass } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { Menu } from '@qaroni-app/layout/types/menu';

@Component({
  selector: 'qaroni-menu-item',
  standalone: true,
  imports: [MatIconModule, NgClass, RouterLink, RouterLinkActive],
  templateUrl: './menu-item.component.html',
  styleUrl: './menu-item.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MenuItemComponent {
  @Input({ required: true }) item!: Menu;
  @Output() closeMenu = new EventEmitter<boolean>();

  public close(): void {
    this.closeMenu.emit(true);
  }
}
